// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"777":"ff81a067","787":"e9daaf8f"}[chunkId] + ".chunk.js";
};